import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const LogzShape = {
  listener_url: Yup.string().label("Listener Domain").max(100).required(),
  logs_shipping_token: Yup.string().label("Logs Shipping Token").max(32).required(),
  metrics_shipping_token: Yup.string().label("Metrics Shipping Token").max(32).required(),
};

export interface LogzInput {
  listener_url: string;
  logs_shipping_token: string;
  metrics_shipping_token: string;
}

export const LogzDefaults = {
  listener_url: "listener.logz.io",
};

yupResolver<LogzInput>(Yup.object().shape(LogzShape));
